import React from "react";

const SlaSidebarIcon: React.FC = () => {
  return (
    <>
      <svg
        width="21"
        height="22"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          d="M12 4a9 9 0 1 1 0 18a9 9 0 1 1 0-18Zm0 1.5a7.5 7.5 0 1 0 0 15a7.5 7.5 0 1 0 0-15Z"
          className="icon"
        />
        <path
          d="M9.5 1.5h5a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1 0-1.5Z"
          className="icon"
        />
        <path d="M11.25 3h1.5v1.6h-1.5Z" className="icon" />
        <path
          d="M17.47 4.97a.75.75 0 0 1 1.06 0l1.5 1.5a.75.75 0 0 1-1.06 1.06l-1.5-1.5a.75.75 0 0 1 0-1.06Z"
          className="icon"
        />
        <path
          d="M11.25 8.5a.75.75 0 0 1 1.5 0v4.19l2.53 2.53a.75.75 0 1 1-1.06 1.06l-2.75-2.75a.75.75 0 0 1-.22-.53Z"
          className="icon"
        />
      </svg>
    </>
  );
};

export default SlaSidebarIcon;
